export default __webpack_public_path__ + "static/media/clock_tick.1bf51d0e.mp3";